import { Button, Collapse } from 'antd'
import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import { useDispatch } from 'react-redux'
import { DisplayDate } from '../../../../components/_utils/appUtils'
import { getPushPathWrapper } from '../../../../routes'
import { RowTable } from '../../../article/articleView/RowTable'

const { Panel } = Collapse

const AbstractDOIDetails = props => {
  let { abstract } = props
  let dispatch = useDispatch()
  let { approvedAbstractPaymentDate, doiProcessDate } = abstract

  let headerTitle = `DOI Details ${
    doiProcessDate ? `(${DisplayDate(doiProcessDate)})` : ''
  }`

  let BtnAction = event => {
    dispatch(getPushPathWrapper('onlineAbstractsGroup.addDoiAbstract', { id: abstract._id }))
    event.stopPropagation()
  }

  let getExtraButton = () => {
    return (
      <React.Fragment>
        {approvedAbstractPaymentDate && !doiProcessDate ? (
          <Button type={'primary'} size={'small'} onClick={BtnAction}>
            Add
          </Button>
        ) : null}
        {doiProcessDate ? (
          <Button type={'primary'} size={'small'} onClick={BtnAction}>
            Edit
          </Button>
        ) : null}
      </React.Fragment>
    )
  }

  return (
    <div>
      <Collapse expandIconPosition={'right'} defaultActiveKey={['1']}>
        <Panel header={headerTitle} key="1" extra={getExtraButton()}>
          <div className={'tableBox striped'}>
            <RowTable
              title={'Date'}
              value={doiProcessDate && DisplayDate(doiProcessDate)}
            />

            <RowTable
              title={'Abstract Title'}
              value={
                abstract.doiTitle
                  ? ReactHtmlParser(abstract.doiTitle)
                  : null
              }
            />

            <RowTable
              title={'Abstract Content'}
              value={
                abstract.doiAbstract ? (
                  <div style={{ width: '75%', marginLeft: '21%' }}>
                    {ReactHtmlParser(abstract.doiAbstract)}
                  </div>
                ) : null
              }
            />

            <RowTable
              title={'Keywords'}
              value={
                abstract.doiKeywordList && abstract.doiKeywordList.length > 0
                  ? abstract.doiKeywordList.map(k => k.keyword).join(', ')
                  : null
              }
            />
          </div>
        </Panel>
      </Collapse>
    </div>
  )
}

export default AbstractDOIDetails